import { createApi } from '@thinknimble/tn-models'
import { axiosInstance } from '../axios-instance'
import {
  vendorBankAccountShape,
  createVendorBankAccountShape,
  vendorBankAccountFilterShape,
} from './models'

export function createVendorBankAccountApi(vendorId: string) {
  return createApi({
    client: axiosInstance,
    baseUri: `/expenses/vendors/${vendorId}/bank-accounts/`,
    models: {
      entity: vendorBankAccountShape,
      create: createVendorBankAccountShape,
      extraFilters: vendorBankAccountFilterShape,
    },
  })
}
